import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";


export default function Navbar() {
  const [open, setOpen] = useState(false);          // menu mobile
  const [megaOpen, setMegaOpen] = useState(false);  // mega menu Ressources (desktop)
  const [ecoleMegaOpen, setEcoleMegaOpen] = useState(false);  // mega menu L'École (desktop)
  const megaRef = useRef(null);
  const ecoleMegaRef = useRef(null);
  const megaTimeoutRef = useRef(null);
  const ecoleMegaTimeoutRef = useRef(null);

  const closeAll = () => {
    setOpen(false);
    setMegaOpen(false);
    setEcoleMegaOpen(false);
  };

  const closeMegaWithDelay = () => {
    if (megaTimeoutRef.current) {
      clearTimeout(megaTimeoutRef.current);
    }
    megaTimeoutRef.current = setTimeout(() => {
      setMegaOpen(false);
    }, 300); // Délai de 300ms avant fermeture
  };

  const cancelCloseDelay = () => {
    if (megaTimeoutRef.current) {
      clearTimeout(megaTimeoutRef.current);
      megaTimeoutRef.current = null;
    }
  };

  const closeEcoleMegaWithDelay = () => {
    if (ecoleMegaTimeoutRef.current) {
      clearTimeout(ecoleMegaTimeoutRef.current);
    }
    ecoleMegaTimeoutRef.current = setTimeout(() => {
      setEcoleMegaOpen(false);
    }, 300); // Délai de 300ms avant fermeture
  };

  const cancelEcoleCloseDelay = () => {
    if (ecoleMegaTimeoutRef.current) {
      clearTimeout(ecoleMegaTimeoutRef.current);
      ecoleMegaTimeoutRef.current = null;
    }
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (!megaRef.current) return;
      if (!megaRef.current.contains(e.target)) setMegaOpen(false);
      if (!ecoleMegaRef.current) return;
      if (!ecoleMegaRef.current.contains(e.target)) setEcoleMegaOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") {
        setMegaOpen(false);
        setEcoleMegaOpen(false);
      }
    };

    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
      if (megaTimeoutRef.current) {
        clearTimeout(megaTimeoutRef.current);
      }
      if (ecoleMegaTimeoutRef.current) {
        clearTimeout(ecoleMegaTimeoutRef.current);
      }
    };
  }, []);

  return (
    <header className="ema-nav">
      <div className="ema-container ema-nav-inner">
        {/* Brand */}
        <Link to="/" className="ema-brand" onClick={closeAll}>
          <img src={logo} alt="EMA" className="ema-logo" />
          <div className="ema-brand-text">
            <span className="ema-brand-name">École de la Magistrature</span>
            <span className="ema-brand-sub">Plateforme officielle</span>
          </div>
        </Link>

        {/* Desktop menu */}
        <nav className="ema-nav-links" aria-label="Navigation principale">
          {/* Mega menu: L'École */}
          <div
            className="ema-mega"
            ref={ecoleMegaRef}
            onMouseEnter={() => {
              cancelEcoleCloseDelay();
              setEcoleMegaOpen(true);
            }}
            onMouseLeave={closeEcoleMegaWithDelay}
          >
            <button
              type="button"
              className={`ema-navlink ema-mega-btn ${ecoleMegaOpen ? "ema-navlink-active" : ""}`}
              aria-haspopup="menu"
              aria-expanded={ecoleMegaOpen}
              onClick={() => setEcoleMegaOpen((v) => !v)}
            >
              L'École
            </button>

            {ecoleMegaOpen && (
              <div className="ema-mega-panel ema-mega-panel-large" role="menu">
                <div className="ema-mega-grid ema-mega-grid-2">

                  {/* À propos */}
                  <div className="ema-mega-col">
                    <div className="ema-mega-title">À propos</div>
                    <NavLink className="ema-mega-item" to="/ecole/presentation" onClick={closeAll}>
                      Présentation
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/ecole/historique" onClick={closeAll}>
                      Historique
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/ecole/mission" onClick={closeAll}>
                      Mission & vision
                    </NavLink>
                  </div>

                  {/* Institution */}
                  <div className="ema-mega-col">
                    <div className="ema-mega-title">Institution</div>
                    <NavLink className="ema-mega-item" to="/ecole/gouvernance" onClick={closeAll}>
                      Gouvernance
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/ecole/organigramme" onClick={closeAll}>
                      Organigramme
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/magistrats-ema" onClick={closeAll}>
                      Magistrats EMA
                    </NavLink>
                  </div>

                  {/* Réalisations */}
                  <div className="ema-mega-col">
                    <div className="ema-mega-title">Réalisations</div>
                    <NavLink className="ema-mega-item" to="/ecole/temoignages" onClick={closeAll}>
                      Témoignages
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/ecole/realisations" onClick={closeAll}>
                      Réalisations
                    </NavLink>
                    <NavLink className="ema-mega-item" to="/ecole/chiffres" onClick={closeAll}>
                      Chiffres clés
                    </NavLink>
                  </div>

                </div>
              </div>
            )}
          </div>

          <NavItem to="/formations" label="Formations" onClick={closeAll} />
          <NavItem to="/concours" label="Concours & Admissions" onClick={closeAll} />

          {/* Mega menu: Ressources */}
          <div
            className="ema-mega"
            ref={megaRef}
            onMouseEnter={() => {
              cancelCloseDelay();
              setMegaOpen(true);
            }}
            onMouseLeave={closeMegaWithDelay}
          >
            <button
              type="button"
              className={`ema-navlink ema-mega-btn ${megaOpen ? "ema-navlink-active" : ""}`}
              aria-haspopup="menu"
              aria-expanded={megaOpen}
              onClick={() => setMegaOpen((v) => !v)}
            >
              Ressources
            </button>

            {megaOpen && (
  <div className="ema-mega-panel" role="menu">
    <div className="ema-mega-grid">

      {/* Médiathèque */}
      <div className="ema-mega-col">
        <div className="ema-mega-title">Médiathèque</div>
        <NavLink className="ema-mega-item" to="/mediatheque" onClick={closeAll}>
          Albums photos
        </NavLink>
        <NavLink className="ema-mega-item" to="/mediatheque/photos" onClick={closeAll}>
          Galerie photos
        </NavLink>
        <NavLink className="ema-mega-item" to="/mediatheque" onClick={closeAll}>
          Vidéos
        </NavLink>
      </div>

      {/* Pédagogie */}
      <div className="ema-mega-col">
        <div className="ema-mega-title">Pédagogie</div>
        <NavLink className="ema-mega-item" to="/proces-fictifs" onClick={closeAll}>
          Procès fictifs
        </NavLink>
      </div>

    </div>
  </div>
)}
          </div>

          <NavItem to="/announcements" label="Actualités" onClick={closeAll} />
          {/* Contact retiré du header (reste dans le footer) */}
        </nav>

        {/* Actions (desktop) */}
        <div className="ema-nav-actions">
          <a
            className="ema-btn ema-btn-ghost ema-hide-sm"
            href="https://moodle.ema.edu.ht"
            target="_blank"
            rel="noreferrer"
            title="Accéder au Campus numérique"
          >
            Campus (Moodle)
          </a>

          <Link className="ema-btn ema-btn-secondary ema-hide-sm" to="/login" onClick={closeAll}>
            Espace candidat
          </Link>

          {/* Mobile burger */}
          <button
            className="ema-burger"
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            type="button"
          >
            <span className="ema-burger-lines" aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="ema-mobile">
          <div className="ema-container ema-mobile-inner">
            <div className="ema-mobile-links">
              <NavLink className="ema-mobile-link" to="/ecole" onClick={closeAll}>L'École</NavLink>
              <NavLink className="ema-mobile-link" to="/ecole/presentation" onClick={closeAll}>Présentation</NavLink>
              <NavLink className="ema-mobile-link" to="/ecole/gouvernance" onClick={closeAll}>Gouvernance</NavLink>
              <NavLink className="ema-mobile-link" to="/magistrats-ema" onClick={closeAll}>Magistrats EMA</NavLink>
              <NavLink className="ema-mobile-link" to="/formations" onClick={closeAll}>Formations</NavLink>
              <NavLink className="ema-mobile-link" to="/concours" onClick={closeAll}>Concours & Admissions</NavLink>
              <NavLink className="ema-mobile-link" to="/mediatheque" onClick={closeAll}>Médiathèque</NavLink>
              <NavLink className="ema-mobile-link" to="/announcements" onClick={closeAll}>Actualités</NavLink>
              {/* Contact retiré du header/mobile */}
            </div>

            <div className="ema-mobile-actions">
              <a className="ema-btn ema-btn-ghost" href="https://moodle.ema.edu.ht" target="_blank" rel="noreferrer" onClick={closeAll}>
                Campus (Moodle)
              </a>
              <Link className="ema-btn ema-btn-secondary" to="/login" onClick={closeAll}>
                Espace candidat
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

function NavItem({ to, label, onClick }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => `ema-navlink ${isActive ? "ema-navlink-active" : ""}`}
    >
      {label}
    </NavLink>
  );
}
